import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';

// ES6 class-style
class ChallengeBanner extends PreLoginPage {

    moreClick = () => {
        console.warn("moreClick");
        if(typeof this.props.moreClick === "function"){
            this.props.moreClick()
        }
    }

    intrestClick = () => {
        console.warn("intrestClick");
        if(typeof this.props.intrestClick === "function"){
            this.props.intrestClick()
        }
    }

  render() {
  	return(
	<div data-p-ga="" id="challengeBanner">			
        <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 challenge">
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-sm-12 ">
                        <h4>{this.rb("challenge.banner.heading1")}</h4>
                        <p>{this.rb("challenge.banner.para1")}</p>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 buttonSec">
                        <button type="button" className="btn btn-primary more" onClick={this.moreClick}> {this.rb("challenge.banner.morebtn")} <i className="material-icons">open_in_new</i></button>   
                    </div>   
                </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 participate">    
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-sm-12">               
                        <h4>{this.rb("challenge.banner.heading2")}</h4>
                        <p>{this.rb("challenge.banner.para2")}</p>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 buttonSec">
                        <button type="button" className="btn btn-primary interested" onClick={this.intrestClick}>{this.rb("challenge.banner.interestbtn")}</button>  
                    </div> 
                </div>   
            </div>  
        </div>
	</div>
  	);
  }
}

export default ChallengeBanner;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/ChallengeBanner.js